import { useRecoilValue } from "recoil";
import { del, get, getPage, post, put } from ".";
import { authAtom } from "..";
import { useAccoutTypeActions } from "./auth";

export const useScheduleActions = () => {
  const auth = useRecoilValue(authAtom);
  const accountType = useAccoutTypeActions();

  return {
    delSchedule,
    postSchedule,
    putSchedule,
    getCalendar,
    getScheduleByDate,
  };

  async function delSchedule(data) {
    const res = await del("delete/schedule", data);
    return res;
  }

  async function postSchedule(data) {
    let params = {
      ...data,
    };

    if (accountType.isCompany()) params.id = auth.user.id;
    if (accountType.isEmployee()) params.id = auth.user.id;

    const res = await post(`${auth.accountType}/schedule/regist`, params);
    return res;
  }

  async function putSchedule(data) {
    let params = {
      ...data,
    };

    if (accountType.isCompany()) params.id = auth.user.id;
    if (accountType.isEmployee()) params.id = auth.user.id;

    const res = await put(`${auth.accountType}/schedule/regist`, params);
    return res;
  }

  async function getScheduleByDate(data) {
    let params = {
      ...data,
    };

    if (accountType.isCompany()) params.id = auth.user.id;
    if (accountType.isEmployee()) params.id = auth.user.id;

    const res = await getPage(`${auth.accountType}/schedule/list`, params);
    return res;
  }

  async function getCalendar(data) {
    let params = {
      ...data,
    };

    if (accountType.isCompany()) params.id = auth.user.id;
    if (accountType.isEmployee()) params.id = auth.user.id;

    const res = await get(`${auth.accountType}/schedule/calendar`, params)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
    return res;
  }
};

export default useScheduleActions;
